<script>
    import {onMount} from 'svelte';

    import store from '../../../Stores/trabajador-store';
    import {validaTrabajador, nombreCompleto} from '../../../Modelos/Trabajador';

    import {url, goto} from '@sveltech/routify';

    import Loading from "../../../Components/UI/Loading.svelte";
    import Error from "../../../Components/UI/Error.svelte";
    import Titulo from "../../../Components/UI/Titulo.svelte";
    import Migas from "../../../Components/UI/Migas/Migas.svelte";
    import Miga from "../../../Components/UI/Migas/Miga.svelte";
    import Formulario from "../../../Components/Trabajadores/Edicion/Formulario.svelte";

    export let id;

    onMount(() => store.cargar(id));

    let trabajador, error, nombre;
    $: nombre = nombreCompleto(trabajador);

    $: trabajador = $store.trabajador;
    $: error = $store.error;
</script>

<svelte:head>
    <title>Edición de {nombre}</title>
</svelte:head>

<style>
    h2 .material-icons {
        font-size: 2.5em;
        vertical-align: bottom;
        line-height: 1;
    }

    @media (min-width: 768px) {
        .fila {
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-gap: var(--padding-global);
        }

        .fila-3 {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            grid-gap: var(--padding-global);
        }
    }
</style>

<Migas>
    <Miga url={$url('/trabajadores')}>Trabajadores</Miga>
    {#if trabajador}
        <Miga url={$url(`/trabajadores/${id}`)}>{nombre}</Miga>
        <Miga actual>Edición de trabajador</Miga>
    {/if}
</Migas>

<Titulo>Edición de trabajador</Titulo>

{#if $store.cargando}
    <Loading/>
{:else if error}
    <Error mensaje={error} on:cancel={() => error = null}/>
{:else if trabajador }
    <Formulario titulo="Edición de {nombre}" on:enviado={() => $goto('/trabajadores')} />
{/if}